import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { branchService } from "@/services/altingross";

export const fetchBranches = createAsyncThunk(
  "branches/fetchList",
  async ({ page = 1, size = 20, field, value, operator } = {}, { rejectWithValue }) => {
    try {
      const res = await branchService.getList({ page, size, field, value, operator });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const createBranch = createAsyncThunk(
  "branches/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await branchService.create(data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateBranch = createAsyncThunk(
  "branches/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await branchService.update(id, data);
      return { id, ...res.data };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const deleteBranch = createAsyncThunk(
  "branches/delete",
  async (id, { rejectWithValue }) => {
    try {
      await branchService.deleteById(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const branchesSlice = createSlice({
  name: "branches",
  initialState: {
    list: [],
    pagination: { page: 1, size: 20, count: 0, totalPages: 1, hasNext: false, hasPrev: false },
    loading: false,
    savingId: null,
    deletingId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranches.pending, (state) => { state.loading = true; })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.loading = false;
        const { items, page, size, count, totalPages, hasNext, hasPrev } = action.payload;
        state.list = items ?? [];
        state.pagination = { page, size, count, totalPages, hasNext, hasPrev };
      })
      .addCase(fetchBranches.rejected, (state) => { state.loading = false; })

      .addCase(createBranch.pending, (state) => { state.savingId = "__new__"; })
      .addCase(createBranch.fulfilled, (state) => { state.savingId = null; })
      .addCase(createBranch.rejected, (state) => { state.savingId = null; })

      .addCase(updateBranch.pending, (state, action) => { state.savingId = action.meta.arg.id; })
      .addCase(updateBranch.fulfilled, (state) => { state.savingId = null; })
      .addCase(updateBranch.rejected, (state) => { state.savingId = null; })

      .addCase(deleteBranch.pending, (state, action) => { state.deletingId = action.meta.arg; })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.deletingId = null;
        state.list = state.list.filter((b) => b.id !== action.payload);
      })
      .addCase(deleteBranch.rejected, (state) => { state.deletingId = null; });
  },
});

export default branchesSlice.reducer;
